import { BranchStatus } from './types'

/**
 * Asked for when no status is picked, which is the request the list has always made - the
 * backend would otherwise drop archived branches.
 */
export const BRANCH_DEFAULT_STATUSES: BranchStatus[] = [
	'ACTIVE',
	'LOCKED',
	'ARCHIVED',
]

/** Deleted branches are only ever listed on request, never by default. */
export const BRANCH_FILTER_STATUSES: BranchStatus[] = [
	...BRANCH_DEFAULT_STATUSES,
	'DELETED',
]

/** Persisted via users/context (settings.branchFilter). */
export type BranchFilterSession = {
	protectedOnly: boolean
	statuses: BranchStatus[]
}

export const EMPTY_BRANCH_FILTER_SESSION: BranchFilterSession = {
	protectedOnly: false,
	statuses: [],
}

export const normalizeBranchFilter = (
	value: Partial<BranchFilterSession> | undefined,
	fallback: BranchFilterSession = EMPTY_BRANCH_FILTER_SESSION,
): BranchFilterSession => ({
	protectedOnly:
		typeof value?.protectedOnly === 'boolean'
			? value.protectedOnly
			: fallback.protectedOnly,
	statuses: Array.isArray(value?.statuses)
		? value.statuses.filter((status) => BRANCH_FILTER_STATUSES.includes(status))
		: fallback.statuses,
})

/** An empty filter is left to the default request rather than sent as one. */
export const isBranchFilterActive = (filter: BranchFilterSession) =>
	filter.protectedOnly || filter.statuses.length > 0
